// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./../assets/images/home_bg.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./../assets/images/home_bg_mobile.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#home_container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.cover_photo {
  height: 100vh;
  min-height: 100vh;
  width: 100%;
  max-width: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  margin-bottom: 2rem;
  box-shadow: 0 4px 10px -1px rgba(0, 0, 0, 0.25);
}

.slogan {
  margin: 0 auto;
  margin-top: 30rem;
  text-align: center;
  width: 50%;
  font-size: 3.2rem;
  color: white;
  text-shadow: 6px 6px 10px black;
  animation: fadeInAnimation ease 4s;
  animation-iteration-count: 1;
}

.subheader {
  display: flex;
  margin: auto;
  font-size: 1.75rem;
  color: rgb(71, 65, 56);
  font-weight: 300;
}

.subheader a {
  font-size: 1.75rem;
  color: rgb(71, 65, 56);
  text-decoration: underline;
  font-weight: 300;
}

@keyframes fadeInAnimation {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.banner {
  display: flex;
  flex-direction: row;
  height: 7rem;
  align-items: center;
  text-align: center;
  font-size: 2.6rem;
  line-height: 2.5rem;
  font-weight: 600;
  margin: auto;
  color: rgb(255, 255, 255);
  font-family: Lato, sans-serif;
}

@media only screen and (max-width: 768px) {
  .cover_photo {
    width: 100%;
    max-width: 100%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: fit;
    height: auto;
  }

  .slogan {
    width: 100%;
    margin: auto;
    font-size: 2.2rem;
    padding-top: 28rem;
    padding-bottom: 10rem;
  }

  .subheader {
    display: flex;
    margin: auto;
    color: rgb(71, 65, 56);
    font-weight: 300;
    text-align: center;
    padding: 0;
    font-size: 1rem;
  }

  .subheader a {
    font-size: 1rem;
    color: rgb(71, 65, 56);
    text-decoration: underline;
    font-weight: 300;
  }

  .banner {
    font-size: 2rem;
    padding: 0 4rem;
    margin-top: 1rem;
  }

  .quality_showcase_info_last {
    font-size: 1rem;
  }
}

@media only screen and (max-width: 380px) {
  .slogan {
    width: 100%;
    margin: auto;
    font-size: 1.8rem;
    padding: 0 1rem;
    padding-top: 18rem;
    padding-bottom: 10rem;
  }

  .subheader {
    display: flex;
    margin: auto;
    color: rgb(71, 65, 56);
    font-weight: 300;
    text-align: center;
    padding: 0;
    font-size: 1rem;
  }

  .subheader a {
    font-size: 1rem;
    color: rgb(71, 65, 56);
    text-decoration: underline;
    font-weight: 300;
  }

  .banner {
    font-size: 1.6rem;
    padding: 0 4rem;
    margin-top: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/home/styles.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,yDAAwD;EACxD,sBAAsB;EACtB,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,YAAY;EACZ,+BAA+B;EAC/B,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE;IACE,WAAW;IACX,eAAe;IACf,yDAA+D;IAC/D,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,sBAAsB;IACtB,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,sBAAsB;IACtB,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;EAClB;AACF","sourcesContent":["#home_container {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.cover_photo {\n  height: 100vh;\n  min-height: 100vh;\n  width: 100%;\n  max-width: 100%;\n  background-image: url('./../assets/images/home_bg.webp');\n  background-size: cover;\n  margin-bottom: 2rem;\n  box-shadow: 0 4px 10px -1px rgba(0, 0, 0, 0.25);\n}\n\n.slogan {\n  margin: 0 auto;\n  margin-top: 30rem;\n  text-align: center;\n  width: 50%;\n  font-size: 3.2rem;\n  color: white;\n  text-shadow: 6px 6px 10px black;\n  animation: fadeInAnimation ease 4s;\n  animation-iteration-count: 1;\n}\n\n.subheader {\n  display: flex;\n  margin: auto;\n  font-size: 1.75rem;\n  color: rgb(71, 65, 56);\n  font-weight: 300;\n}\n\n.subheader a {\n  font-size: 1.75rem;\n  color: rgb(71, 65, 56);\n  text-decoration: underline;\n  font-weight: 300;\n}\n\n@keyframes fadeInAnimation {\n  0% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n\n.banner {\n  display: flex;\n  flex-direction: row;\n  height: 7rem;\n  align-items: center;\n  text-align: center;\n  font-size: 2.6rem;\n  line-height: 2.5rem;\n  font-weight: 600;\n  margin: auto;\n  color: rgb(255, 255, 255);\n  font-family: Lato, sans-serif;\n}\n\n@media only screen and (max-width: 768px) {\n  .cover_photo {\n    width: 100%;\n    max-width: 100%;\n    background-image: url('./../assets/images/home_bg_mobile.webp');\n    background-size: fit;\n    height: auto;\n  }\n\n  .slogan {\n    width: 100%;\n    margin: auto;\n    font-size: 2.2rem;\n    padding-top: 28rem;\n    padding-bottom: 10rem;\n  }\n\n  .subheader {\n    display: flex;\n    margin: auto;\n    color: rgb(71, 65, 56);\n    font-weight: 300;\n    text-align: center;\n    padding: 0;\n    font-size: 1rem;\n  }\n\n  .subheader a {\n    font-size: 1rem;\n    color: rgb(71, 65, 56);\n    text-decoration: underline;\n    font-weight: 300;\n  }\n\n  .banner {\n    font-size: 2rem;\n    padding: 0 4rem;\n    margin-top: 1rem;\n  }\n\n  .quality_showcase_info_last {\n    font-size: 1rem;\n  }\n}\n\n@media only screen and (max-width: 380px) {\n  .slogan {\n    width: 100%;\n    margin: auto;\n    font-size: 1.8rem;\n    padding: 0 1rem;\n    padding-top: 18rem;\n    padding-bottom: 10rem;\n  }\n\n  .subheader {\n    display: flex;\n    margin: auto;\n    color: rgb(71, 65, 56);\n    font-weight: 300;\n    text-align: center;\n    padding: 0;\n    font-size: 1rem;\n  }\n\n  .subheader a {\n    font-size: 1rem;\n    color: rgb(71, 65, 56);\n    text-decoration: underline;\n    font-weight: 300;\n  }\n\n  .banner {\n    font-size: 1.6rem;\n    padding: 0 4rem;\n    margin-top: 1rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
